import { useNgSession } from "@/shared/ng/ng-session";

export function ngHandleMmi(): void {
    // do this only in case ng framework is ready and user is not logged in
    if (useNgSession().isLoggedIn.value) return;

    // 248 = Kurzove sazky
    ng_fw.setDefaultGameVerticalID(248);
}
